import Feature from "src/js/stores/user/Feature";
import { ConstraintsCategory } from "../../Constraints/types";
import { Layer, LayerGroup } from "../types";
import { AmenitiesLayerTypeUS } from "../layer_types/AmenitiesLayerType";

export const US_AMENITIES: Layer = {
  id: ConstraintsCategory.US_AMENITIES,
  layerType: AmenitiesLayerTypeUS,
  hideByDefault: true,
  group: LayerGroup.PEOPLE,
  icon: "lt-layer-amenities",
  description: "Transport, schools, healthcare etc",
  title: "Amenities",
  requiredFeatureAccess: [Feature.amenitiesLayerUS],
  toggleable: true,
  excludeFromReport: true,
  layerConfig: {
    rootCategory: ConstraintsCategory.US_AMENITIES,
    categorySchema: [
      { key: "us_schools_elementary" },
      { key: "us_schools_middle" },
      { key: "us_schools_high" },
      { key: "us_schools_combination" },
      { key: "us_schools_other" },
      { key: "us_schools_private_elementary" },
      { key: "us_schools_private_secondary" },
      { key: "us_schools_private_combined" },
    ],
  },
  zoomConfig: {
    minVisualisationZoom: 10,
  },
};
